// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3Qq-R","inputWrap":"CustomTip_inputWrap__9rffh"};